import { createFinishStepContent } from '../FinishStepContent';
import { closeSidebarPanel, openPersonalizationSubmenu } from '../sidebarHelpers';

const exploreRecommenderAnalytics = (baseUrl, navigate, user) => {
  const activeTabSelector = '.active [data-tour="recommendersForPage"]';
  const activeTabFirstRecommenderSelector = `${activeTabSelector} > div:first-child`;

  return {
    id: 'exploreRecommenderAnalytics',
    title: 'Explore Recommender analytics',
    steps: [
      {
        selector: '[data-tour="webPersonalizationLink"]',
        content: <p>Click on the "Personalization" menu item in the navigation.</p>,
      },
      {
        actionBefore: () => openPersonalizationSubmenu('[data-tour="recommenderLink"]'),
        selector: '[data-tour="recommenderLink"]',
        content: <p>Click on the "Product Blocks" in the navigation.</p>,
      },
      {
        actionBefore: () => {
          closeSidebarPanel();
          navigate(`${baseUrl}/pages?type=recommenders`, true);
        },
        selector: activeTabSelector,
        content: <p>Each element in Releva has dedicated performance statistics.</p>,
      },
      {
        selector: `${activeTabFirstRecommenderSelector} [data-tour="pageViewStats"]`,
        content: <p>This is the total number of page views for this page.</p>,
      },
      {
        selector: `${activeTabFirstRecommenderSelector} [data-tour="recommenderImpressionStats"]`,
        content: <p>The number refers to the total number of impressions per Product Block on a certain page.</p>,
      },
      {
        selector: `${activeTabFirstRecommenderSelector} [data-tour="recommenderClicksStats"]`,
        content: (
          <p>
            The number of clicks is self-explanatory, on the right of the number you can see the percentage of people
            that viewed your pages and clicked on a Product Block.
          </p>
        ),
      },
      {
        selector: `${activeTabFirstRecommenderSelector} [data-tour="recommenderConversionsStats"]`,
        content: (
          <p>
            The conversions are the number of people that clicked on a recommended product and added it to their cart.
          </p>
        ),
      },
      {
        selector: `${activeTabFirstRecommenderSelector} [data-tour="recommenderPurchasesStats"]`,
        content: (
          <p>
            Here you can see the number of complete purchases with products from each product block. If this number is
            very low you might need to make some changes so that it shows more relevant products to your customers.
          </p>
        ),
      },
      {
        selector: `${activeTabFirstRecommenderSelector} [data-tour="recommenderRevenueStats"]`,
        content: (
          <p>
            The revenue from each product that has been purchased after the customer click on it in a product block is
            added to this stat on its own, the entire cart total is not attributed to this stat.
          </p>
        ),
      },
      {
        actionBefore: () => navigate(`${baseUrl}/guide`, true),
        selector: '[data-tour="userGuideHeading"]',
        content: createFinishStepContent(),
      },
    ],
    isComplete: !!user.userActions.find(
      (a) => a.action === 'taskCompleted' && a.context.task === 'exploreRecommenderAnalytics'
    ),
  };
};

export default exploreRecommenderAnalytics;
